export const addressKeyFactory = {
  all: [{ scope: 'address' }] as const,
  searchByZipCode: (zipCode: string) =>
    [{ ...addressKeyFactory.all[0], entity: 'search', zipCode }] as const,
}
